import React from 'react';
import Footer from '../../components/footer';
import { Galery } from '../../components/galery';
import Navbar from '../../components/navbar';
import { People } from '../../components/people';
import { SlideshowAbout } from '../../components/slideshow';
import Testimonials from '../../components/testimonials';


function About (){
    return(        
        <body>
        <Navbar/>
        <hr className='hr-min'/>
        <SlideshowAbout/>
        <hr className='hr-min'/>
        <Galery/>
        <hr className='hr-max'/>
        <Testimonials/>
        <hr className='hr-max'/>
        <People/>
        <Footer/>
        </body>
    )
}
export default About;